import { useParams, useNavigate } from "react-router-dom";
import { useMemo, useState } from "react";
import YildizArkaplan from "../components/YildizArkaplan";
import { useFal } from "../context/FalContext";
import { FALCILAR } from "../data/falcilar";
import { burcKisilikSec } from "../data/yorumlar/burc_kisilik";
import { useTranslation } from "react-i18next";
import { supabase } from "../supabaseClient";
import { isNativeApp, showFalHemenOkuAd } from "../utils/nativeBridge";

const FAL_ISIM_KEY = {
  kahve: "readings.coffee",
  el: "readings.hand",
  yuz: "readings.face",
  iliski: "readings.relationship",
};

export default function FalDetay() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { fallar, falOkundu, fetchFallar } = useFal();
  const [kisaltYukleniyor, setKisaltYukleniyor] = useState(false);
  const { t } = useTranslation();

  const fal = fallar.find((f) => f.id === id);

  const falciBul = (falciId) => {
    return FALCILAR.find((f) => f.id === falciId) || {
      emoji: "🔮", renk: "#6B3FA0", parlak: "#A855F7", isim: "Falcı"
    };
  };

  if (!fal) return (
    <div style={{ color: "#fff", padding: 40, textAlign: "center" }}>
      Fal bulunamadı.
    </div>
  );

  const falci = falciBul(fal.falci_id);

  const BURC_SEMBOL = {
    "Koç": "♈", "Boğa": "♉", "İkizler": "♊", "Yengeç": "♋",
    "Aslan": "♌", "Başak": "♍", "Terazi": "♎", "Akrep": "♏",
    "Yay": "♐", "Oğlak": "♑", "Kova": "♒", "Balık": "♓",
  };

  const burc = fal.burc || (() => {
    if (!fal.ek_not || fal.fal_turu === "ruya") return null;
    const burclar = Object.keys(BURC_SEMBOL);
    const lower = fal.ek_not.toLowerCase();
    return burclar.find((b) => lower.includes(b.toLowerCase())) || null;
  })();

  const burcKisilik = useMemo(() => burc ? burcKisilikSec(burc) : "", [burc]);

  const bekleyenSure = Math.max(0, new Date(fal.hazir_olma_zamani) - Date.now());
  const bekliyor = fal.durum === "bekliyor" && bekleyenSure > 0;
  const dakika = Math.ceil(bekleyenSure / 1000 / 60);

  const handleOku = () => {
    if (fal.durum === "hazir") falOkundu(fal.id);
  };

  const sureKisalt = () => {
    setKisaltYukleniyor(true);
    showFalHemenOkuAd()
      .then(async () => {
        await supabase.from('fallar')
          .update({ hazir_olma_zamani: new Date(Date.now() + 3 * 60 * 1000).toISOString() })
          .eq('id', fal.id);
        await fetchFallar();
      })
      .catch(() => {})
      .finally(() => setKisaltYukleniyor(false));
  };

  return (
    <div style={{
      minHeight: "100vh",
      background: "linear-gradient(180deg, #0a0718 0%, #110d24 40%, #0d0a1a 100%)",
      position: "relative",
      fontFamily: "'Trebuchet MS', Tahoma, sans-serif",
      maxWidth: 420, margin: "0 auto", overflowY: "auto",
    }}>
      <style>{`
        @keyframes kart-gir { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes donuyor { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
        @keyframes nabiz { 0%, 100% { opacity: 0.6; transform: scale(1); } 50% { opacity: 1; transform: scale(1.08); } }
        * { box-sizing: border-box; margin: 0; padding: 0; }
        ::-webkit-scrollbar { display: none; }
      `}</style>

      <YildizArkaplan />

      <div style={{ position: "relative", zIndex: 1, paddingBottom: 120 }}>

        {/* Geri */}
        <div style={{ padding: "52px 24px 0" }}>
          <button onClick={() => navigate("/fallarim")} style={{
            background: "rgba(255,255,255,0.07)", border: "1px solid rgba(255,255,255,0.12)",
            borderRadius: 12, padding: "8px 16px",
            color: "rgba(255,255,255,0.7)", fontSize: 13, cursor: "pointer",
          }}>
            {t("readingDetail.back")}
          </button>
        </div>

        {/* Falcı Header */}
        <div style={{
          margin: "20px 24px 0", borderRadius: 16,
          background: `${falci.renk}33`, border: `1px solid ${falci.parlak}33`,
          padding: "16px", display: "flex", alignItems: "center", gap: 14,
          animation: "kart-gir 0.5s ease backwards",
        }}>
          <div style={{ fontSize: 36 }}>{falci.emoji}</div>
          <div>
            <div style={{ fontSize: 16, fontWeight: 700, color: "#fff", fontFamily: "Georgia, serif" }}>
              {falci.isim}
            </div>
            <div style={{ fontSize: 12, color: falci.parlak, marginTop: 2 }}>
              {t(FAL_ISIM_KEY[fal.fal_turu])}
            </div>
          </div>
          <div style={{ marginLeft: "auto", fontSize: 11, color: "rgba(255,255,255,0.35)", textAlign: "right" }}>
            {fal.created_at ? new Date(fal.created_at).toLocaleDateString(undefined, {
              day: "numeric", month: "long", hour: "2-digit", minute: "2-digit"
            }) : ""}
          </div>
        </div>

        {/* BEKLİYOR */}
        {bekliyor && (
          <div style={{ margin: "20px 24px 0", textAlign: "center", animation: "kart-gir 0.5s ease backwards" }}>
            <div style={{ fontSize: 56, marginBottom: 16, animation: "donuyor 8s linear infinite", display: "inline-block" }}>
              🔮
            </div>
            <div style={{ fontSize: 18, fontWeight: 700, color: "#fff", fontFamily: "Georgia, serif", marginBottom: 8 }}>
              {t("readingDetail.interpreting")}
            </div>
            <div style={{ fontSize: 14, color: "rgba(255,255,255,0.5)", marginBottom: 20 }}>
              <span style={{ color: falci.parlak, fontWeight: 700 }}>{falci.isim}</span>{" "}
              {t("readingDetail.interpretingDesc", { reader: "", min: dakika }).replace(`  ${dakika}`, ` ${dakika}`)}
            </div>
            <div style={{
              background: "rgba(168,85,247,0.1)", border: "1px solid rgba(168,85,247,0.25)",
              borderRadius: 16, padding: "14px 18px",
              fontSize: 13, color: "rgba(255,255,255,0.6)", lineHeight: 1.6,
            }}>
              {t("readingDetail.notificationNote")}
            </div>
            {isNativeApp() && bekleyenSure > 3 * 60 * 1000 && (
              <button onClick={sureKisalt} disabled={kisaltYukleniyor} style={{
                marginTop: 14, width: "100%", padding: "14px", borderRadius: 14, border: "none",
                background: "linear-gradient(135deg, #7c3aed, #db2777)", color: "#fff",
                fontSize: 15, fontWeight: 700, cursor: "pointer", opacity: kisaltYukleniyor ? 0.6 : 1,
              }}>
                {kisaltYukleniyor ? "Reklam yükleniyor..." : "⚡ Reklam İzle, Süreyi Kısalt"}
              </button>
            )}
            <div style={{
              margin: "20px 0 0", textAlign: "left",
              background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.08)",
              borderRadius: 14, padding: "16px",
            }}>
              <div style={{ fontSize: 11, color: "rgba(200,170,255,0.6)", letterSpacing: 1.5, textTransform: "uppercase", fontWeight: 600, marginBottom: 8 }}>
                {t("readingDetail.yourNote")}
              </div>
              <div style={{ fontSize: 13, color: "rgba(255,255,255,0.6)", lineHeight: 1.6 }}>
                {fal.ek_not}
              </div>
            </div>
          </div>
        )}

        {/* HAZIR veya OKUNDU */}
        {!bekliyor && (
          <div style={{ animation: "kart-gir 0.6s ease backwards" }}>

            {fal.durum === "hazir" && (
              <div style={{
                margin: "16px 24px 0",
                background: "rgba(244,114,182,0.15)", border: "1px solid rgba(244,114,182,0.3)",
                borderRadius: 14, padding: "12px 16px",
                display: "flex", alignItems: "center", gap: 10,
                animation: "nabiz 2s ease-in-out infinite",
              }}>
                <span style={{ fontSize: 18 }}>✨</span>
                <span style={{ fontSize: 13, color: "#F472B6", fontWeight: 700 }}>
                  {t("readingDetail.readyBadge")}
                </span>
              </div>
            )}

            {/* Kullanıcı Adı */}
            {fal.kullanici_adi && (
              <div style={{
                fontSize: 22, fontWeight: 800, color: "#fff",
                fontFamily: "Georgia, serif", marginBottom: 8,
                padding: "20px 24px 0",
              }}>
                {fal.kullanici_adi}
              </div>
            )}

            {/* Burç Kişilik */}
            {burc && burcKisilik && (
              <div style={{
                background: "rgba(168,85,247,0.08)",
                border: "1px solid rgba(168,85,247,0.2)",
                borderRadius: 14, padding: "14px 16px",
                margin: "0 24px 16px",
              }}>
                <div style={{ fontSize: 13, color: "#C084FC", fontWeight: 700, marginBottom: 6 }}>
                  {BURC_SEMBOL[burc]} {burc}
                </div>
                <div style={{
                  fontSize: 13, color: "rgba(255,255,255,0.7)",
                  lineHeight: 1.7, fontStyle: "italic",
                }}>
                  {burcKisilik}
                </div>
              </div>
            )}

            {/* Yorum */}
            <div style={{ padding: "0 24px" }}>
              <div style={{ fontSize: 13, color: "rgba(200,170,255,0.6)", letterSpacing: 1.5, textTransform: "uppercase", fontWeight: 600, marginBottom: 14 }}>
                {t("readingDetail.readerComment", { reader: falci.isim })}
              </div>
              <div
                onClick={handleOku}
                style={{
                  background: `linear-gradient(135deg, ${falci.renk}22 0%, rgba(255,255,255,0.03) 100%)`,
                  border: `1px solid ${falci.parlak}33`,
                  borderRadius: 20, padding: "22px",
                  cursor: fal.durum === "hazir" ? "pointer" : "default",
                  position: "relative", overflow: "hidden",
                }}
              >
                <div style={{ fontSize: 28, marginBottom: 14 }}>{falci.emoji}</div>

                {fal.durum === "hazir" && (
                  <div style={{
                    position: "absolute", inset: 0, backdropFilter: "blur(8px)",
                    background: "rgba(10,7,24,0.6)",
                    display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
                    gap: 12, borderRadius: 20,
                  }}>
                    <div style={{ fontSize: 36 }}>🔮</div>
                    <div style={{ fontSize: 15, fontWeight: 700, color: "#fff", fontFamily: "Georgia, serif" }}>
                      {t("readingDetail.tapToOpen")}
                    </div>
                    <div style={{ fontSize: 12, color: "rgba(255,255,255,0.5)" }}>
                      {t("readingDetail.readyQuestion")}
                    </div>
                  </div>
                )}

                <div style={{
                  fontSize: 16, color: "rgba(255,255,255,0.85)",
                  lineHeight: 1.8, fontFamily: "Arial, 'Helvetica Neue', Helvetica, sans-serif",
                  whiteSpace: "pre-wrap",
                }}>
                  {fal.yorum}
                </div>
              </div>
            </div>

            {/* Kullanıcının Notu */}
            <div style={{
              margin: "16px 24px 0",
              background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.08)",
              borderRadius: 14, padding: "16px",
            }}>
              <div style={{ fontSize: 11, color: "rgba(200,170,255,0.6)", letterSpacing: 1.5, textTransform: "uppercase", fontWeight: 600, marginBottom: 8 }}>
                {t("readingDetail.yourNote")}
              </div>
              <div style={{ fontSize: 13, color: "rgba(255,255,255,0.6)", lineHeight: 1.6 }}>
                {fal.ek_not}
              </div>
            </div>

            {/* Tekrar Fal Bak */}
            <div style={{ padding: "20px 24px 0" }}>
              <button onClick={() => navigate(`/falci/${fal.falci_id}`)} style={{
                width: "100%", padding: "14px", borderRadius: 14,
                background: `linear-gradient(135deg, ${falci.renk} 0%, ${falci.parlak}99 100%)`,
                border: "none", color: "#fff", fontSize: 14,
                fontWeight: 700, cursor: "pointer", fontFamily: "Georgia, serif",
              }}>
                {falci.emoji} {t("readingDetail.readAgain")}
              </button>
            </div>

            {/* Paylaş */}
            {fal.durum === "okundu" && (
              <div style={{ padding: "10px 24px 0" }}>
                <button
                  onClick={async () => {
                    const falTuruIsim = t(FAL_ISIM_KEY[fal.fal_turu]);
                    const paylasimMetni = `🔮 ${falci.isim} — ${falTuruIsim}:\n\n"${fal.yorum || ""}"\n\n✨ https://www.remil.app`;
                    if (navigator.share) {
                      try { await navigator.share({ title: `${falci.isim} — ${falTuruIsim}`, text: paylasimMetni }); } catch (e) {}
                    } else {
                      navigator.clipboard.writeText(paylasimMetni);
                      alert(t("readingDetail.copied"));
                    }
                  }}
                  style={{
                    width: "100%", padding: "14px", borderRadius: 14,
                    background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.15)",
                    color: "rgba(255,255,255,0.7)", fontSize: 14, fontWeight: 600, cursor: "pointer",
                    display: "flex", alignItems: "center", justifyContent: "center", gap: 8,
                  }}
                >
                  {t("readingDetail.share")}
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}